export * from "./api";
export * from "./query-client";

export const OTP_EXPIRATION_TIME = Number(
  import.meta.env.VITE_OTP_EXPIRATION_TIME || 120
);
export const BUYER_PORTAL_URL = import.meta.env.VITE_BUYER_PORTAL_URL;
export const IS_DEV = import.meta.env.DEV;
export const ENABLE_REGISTER = import.meta.env.VITE_ENABLE_REGISTER === "true";
export const ENABLE_REGENERATE_INVOICE =
  import.meta.env.VITE_ENABLE_REGENERATE_INVOICE === "true";
